import { render, staticRenderFns } from "./DestroyTime.vue?vue&type=template&id=71ba6a50&"
import script from "./DestroyTime.vue?vue&type=script&lang=js&"
export * from "./DestroyTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports